import { FC } from 'react';

import styled from 'styled-components';

import { InfoIcon } from '@assets/icons';
import IconLabel from '@components/ui/labels/icon/IconLabel';

const Wrapper = styled.div`
  height: 100%;
  background-color: rgba(4, 169, 133, 0.1) !important;
  & > div:first-child {
    padding: 4px 3px;
  }

  & div {
    height: 100%;
    padding: 0;
  }

  & span {
    margin-left: 0;
  }
`;

const CustomIconLabel = styled(IconLabel)`
  background-color: rgba(4, 169, 133, 0.1) !important;
  & > div:first-child {
    margin-left: 3px;
    display: flex;
    align-items: center;
    margin-top: 0;
  }
`;

const FreeCancellation: FC = () => {
  return (
    <Wrapper>
      <CustomIconLabel
        text='İptal Politikası'
        icon={InfoIcon}
        color='darkGreen'
        iconColor='darkGreen'
        iconSize={14}
        iconLocation='right'
      />
    </Wrapper>
  );
};

export default FreeCancellation;
